import Link from "next/link";
import Divider from "../Divider";
import DescParagraph from "./DescParagraph";
import Title from "./Title";
import { useTranslations } from "next-intl";

interface IProps {
  category: string;
  title: string;
  desc: string;
  href: string;
}
function PopularDestinationsCTA(params: IProps) {
  const t = useTranslations("News");
  return (
    <div
      className=" lg:col-start-3 col-span-2 lg:col-span-1 lg:row-start-2 row-start-4
        space-y-[20px] lg:space-y-[60px] lg:px-[24px] h-full 
        justify-between"
    >
      <div className=" space-y-[12px] lg:mt-[42px] mt-[20px]">
        <span
          className="text-white uppercase text-[20px]
           leading-[1.2]"
        >
          {params.category}
        </span>
        <Divider background="#888" />
      </div>
      <div className="lg:space-y-[20px] space-y-[12px]">
        <Title heading="h2">{params.title}</Title>
        <DescParagraph>{params.desc}</DescParagraph>
      </div>
      <div className="lg:mt-[0px] pt-[20px]">
        <Link
          href={params.href}
          className=" !text-black !no-underline bg-white rounded-[10px]
             text-[16px] font-bold tracking-[-0.48x] leading-[1.2] px-[32px]
              py-[14px]"
        >
          {t("start_now")}
        </Link>
      </div>
    </div>
  );
}

export default PopularDestinationsCTA;
